import React, { HTMLAttributes } from 'react';
import styled, { keyframes } from 'styled-components';
import BndlLoading_TestId from './index.testid';

const BndlLoading: React.FCC<
  HTMLAttributes<HTMLDivElement> & { dataTestId?: string }
> = ({ dataTestId, ...props }) => (
  <Container
    data-testid={dataTestId || BndlLoading_TestId.LoadingAnimation}
    {...props}
  >
    <SVGContainer
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="270.000000pt"
      height="261.000000pt"
      viewBox="0 0 540.000000 522.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,522.000000) scale(0.100000,-0.100000)"
        fill="none"
      >
        <N d="M4415 5051 l-290 -26 -3 -443 c-1 -243 -4 -442 -6 -442 -1 0 -264 175 -583 388 l-580 389 -59 -4 c-32 -2 -69 -6 -81 -9 l-23 -4 0 -990 c0 -786 3 -990 13 -989 6 0 149 12 317 27 l305 27 3 444 c2 374 4 442 16 438 8 -3 271 -177 585 -386 l571 -381 54 0 c29 0 68 3 85 6 l31 7 0 988 0 989 -32 -1 c-18 -1 -163 -13 -323 -28z" />
        <B d="M1405 4778 c-66 -5 -343 -28 -615 -51 l-495 -42 4 -990 c2 -545 4 -991 5 -991 1 -2 237 18 911 76 193 17 391 39 440 49 424 90 646 320 633 655 -3 89 -8 110 -37 173 -23 50 -51 89 -87 123 -49 46 -141 100 -171 100 -23 0 -13 15 22 34 55 30 133 120 167 193 25 53 33 84 36 148 13 249 -120 422 -380 495 -58 16 -285 44 -308 38 -3 0 -59 -5 -125 -10z m172 -478 c43 -26 63 -68 63 -130 0 -79 -37 -133 -112 -164 -24 -10 -143 -24 -351 -41 -173 -14 -320 -25 -326 -25 -17 0 -15 329 2 335 24 8 484 43 587 44 88 1 110 -2 137 -19z m47 -698 c42 -25 68 -64 73 -113 12 -101 -42 -183 -140 -212 -39 -12 -632 -68 -710 -67 -4 0 -6 82 -5 183 l3 182 320 27 c338 28 411 28 459 0z" />
        <L d="M3100 2434 c-135 -12 -260 -23 -277 -23 l-33 -1 0 -996 0 -995 53 6 c28 3 399 37 822 75 424 38 789 72 813 75 l42 6 0 240 0 239 -22 0 c-13 0 -264 -23 -558 -50 -294 -27 -543 -50 -552 -50 -17 0 -18 42 -18 750 0 594 -3 750 -12 749 -7 -1 -123 -12 -258 -25z" />
        <D d="M743 2222 c-243 -21 -445 -41 -448 -44 -4 -3 -3 -447 1 -987 l7 -981 36 0 c106 0 919 74 1006 91 615 124 998 590 945 1148 -13 138 -32 208 -90 327 -95 195 -277 350 -500 422 -214 70 -363 74 -957 24z m622 -467 c196 -50 316 -180 345 -372 44 -282 -151 -545 -449 -608 -57 -12 -299 -35 -368 -35 l-23 0 0 504 0 504 98 7 c53 3 108 7 122 9 77 9 222 4 275 -9z" />
      </g>
    </SVGContainer>
  </Container>
);

const Container = styled.div<{}>`
  max-width: 480px;
  margin: 2rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SVGContainer = styled.svg<{}>`
  width: 100%;
`;

const DASH_ARRAY = 10500;
const dash = keyframes`
  50% { stroke-dashoffset: 0; }
  to { stroke-dashoffset: ${DASH_ARRAY}; }
`;

const Path = styled.path<{}>`
  stroke-width: 10px;
  stroke-dasharray: ${DASH_ARRAY};
  stroke-dashoffset: ${DASH_ARRAY};
  animation: ${dash} 5s ease-in-out infinite;
  fill: transparent;
`;

const B = styled(Path)<{}>`
  stroke: #1e2647;
`;
const N = styled(Path)<{}>`
  stroke: #f16b20;
`;
const D = styled(Path)<{}>`
  stroke: #ffb464;
`;
const L = styled(Path)<{}>`
  stroke: #5c7fd6;
`;

export default BndlLoading;
